<template>
  <div class="notification-container">
    <!-- 1. Üst Bar Bildirimleri (Notification Banner) -->
    <section v-if="activeBanner" class="top-banner-notice" aria-label="Duyuru ve Bildirim Banner">
      <div class="container top-banner__inner">
        <div class="top-banner__info">
          <span class="top-banner__icon" aria-hidden="true">
            <i class="bi bi-megaphone-fill"></i>
          </span>
          <div class="top-banner__copy">
            <strong class="top-banner__title">{{ activeBanner.title }}</strong>
            <div class="top-banner__text" v-html="activeBanner.content"></div>
          </div>
        </div>

        <div class="top-banner__actions">
          <!-- İlgileniyorum -->
          <button 
            v-if="activeBanner.isShowInterestedButton" 
            class="top-banner__btn top-banner__btn--primary"
            @click="handleBannerAction(activeBanner, 'interested')">
            İlgileniyorum
          </button>

          <!-- Daha Sonra Hatırlat -->
          <button 
            v-if="activeBanner.isShowRemindMeLaterButton" 
            class="top-banner__btn top-banner__btn--secondary"
            @click="handleBannerAction(activeBanner, 'remind_later')">
            Daha Sonra
          </button>

          <!-- Kapat Butonu -->
          <button 
            v-if="activeBanner.isShowCloseButton !== false" 
            class="top-banner__close"
            @click="closeBanner(activeBanner)"
            aria-label="Kapat">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- 2. Öğrenciye Özel Kampanya Modalı (Campaign Modal) -->
    <StudentCampaignModal 
      :notification="activeModalNotification"
      @close="onModalClose"
      @action="onModalAction"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { GetCookie, SetCookie } from "@/common/cookie-helper";
import StudentCampaignModal from "@/components/Shared/StudentCampaignModal.vue";

export default {
  name: "NotificationForTopPage",
  components: {
    StudentCampaignModal
  },
  data() {
    return {
      bannerList: [],
      modalList: [],
      activeBanner: null,
      activeModalNotification: null
    };
  },
  methods: {
    ...mapActions(["GetNotification"]),

    CheckNotificationForCookie(notifications) {
      let result = [];
      for (let i = 0; i < notifications.length; i++) {
        const n = notifications[i];
        if (n.cookieKey) {
          const cookie = GetCookie(n.cookieKey);
          if (!cookie || cookie === "") {
            result.push(n);
          }
        } else {
          result.push(n);
        }
      }
      return result;
    },

    async Init() {
      try {
        const [resTop, resModal] = await Promise.all([
          this.GetNotification({ viewZone: 1 }).catch(() => []),
          this.GetNotification({ viewZone: 2 }).catch(() => [])
        ]);

        const topList = Array.isArray(resTop) ? resTop : [];
        const modalListFromApi = Array.isArray(resModal) ? resModal : [];
        const allNotifications = [...topList, ...modalListFromApi];

        if (allNotifications.length > 0) {
          const validNotifications = this.CheckNotificationForCookie(allNotifications);
          
          this.modalList = validNotifications.filter(n => n.notificationViewZone === 2 || n.isModal === true);
          this.bannerList = validNotifications.filter(n => n.notificationViewZone === 1 && !n.isModal);

          if (this.bannerList.length > 0) {
            this.activeBanner = this.bannerList[0];
          }

          if (this.modalList.length > 0) {
            this.activeModalNotification = this.modalList[0];
          }
        }
      } catch (err) {
        // Sessiz hata yönetimi
      }
    },

    closeBanner(notification) {
      if (notification && notification.cookieKey) {
        const duration = notification.remindMeLaterDuration || 1440;
        SetCookie(notification.cookieKey, "dismissed", duration);
      }
      this.activeBanner = null;
    },

    handleBannerAction(notification, actionType) {
      if (actionType === 'remind_later' && notification.cookieKey) {
        const duration = notification.remindMeLaterDuration || 1440;
        SetCookie(notification.cookieKey, "true", duration);
      } else if (actionType === 'interested') {
        if (this.$route.path !== '/market') {
          this.$router.push('/market');
        }
      }
      this.closeBanner(notification);
    },

    onModalClose() {
      this.activeModalNotification = null;
    },

    onModalAction() {
      this.activeModalNotification = null;
    }
  },
  mounted() {
    this.Init();
  }
};
</script>

<style scoped>
.top-banner-notice {
  background: linear-gradient(90deg, #1b5329 0%, var(--brand-link) 100%);
  color: #ffffff;
  border-bottom: 1px solid #1a5e2a;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.top-banner__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.top-banner__info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.top-banner__icon {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 16px;
}

.top-banner__copy {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.top-banner__title {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.top-banner__text {
  font-size: 13px;
  color: #e2f4ed;
}

.top-banner__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.top-banner__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  border: 0;
  cursor: pointer;
  transition: all 150ms ease;
}

.top-banner__btn--primary {
  background: #ffffff;
  color: var(--brand-link);
}

.top-banner__btn--primary:hover {
  background: #edf7ee;
  color: #1e632d;
}

.top-banner__btn--secondary {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.top-banner__btn--secondary:hover {
  background: rgba(255, 255, 255, 0.25);
}

.top-banner__close {
  background: transparent;
  border: 0;
  color: rgba(255, 255, 255, 0.7);
  padding: 4px 8px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  transition: color 150ms ease;
}

.top-banner__close:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
  .top-banner__inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .top-banner__actions {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>